import { __assign } from "tslib";
import Vue from 'vue';
export default Vue.extend({
    props: {
        direction: {
            type: String,
            default: 'horizontal'
        },
        hAlign: {
            type: String,
            default: null
        },
        vAlign: {
            type: String,
            default: null
        },
        wrap: {
            type: Boolean,
            default: false
        }
    },
    // @ts-ignore
    getClassMap: function (props) {
        var classMap = {
            'flex-column': props.direction == 'vertical',
            'flex-wrap': props.wrap
        };
        if (props.direction == 'horizontal') {
            classMap = __assign(__assign({}, classMap), { 'justify-content-start': props.hAlign == 'left', 'justify-content-end': props.hAlign == 'right', 'justify-content-center': props.hAlign == 'center', 'justify-content-between': props.hAlign == 'spread', 'justify-content-around': props.hAlign == 'around', 'align-items-start': props.vAlign == 'top', 'align-items-end': props.vAlign == 'bottom', 'align-items-center': props.vAlign == 'center' });
        }
        else {
            classMap = __assign(__assign({}, classMap), { 'justify-content-start': props.vAlign == 'top', 'justify-content-end': props.vAlign == 'bottom', 'justify-content-center': props.vAlign == 'center', 'justify-content-between': props.vAlign == 'spread', 'justify-content-around': props.vAlign == 'around', 'align-items-start': props.hAlign == 'left', 'align-items-end': props.hAlign == 'right', 'align-items-center': props.hAlign == 'center' });
        }
        return classMap;
    }
});
